import { FC } from 'react'
import { ISetting } from '../../../model/ISettings'
import FormBlock from '../form/FormBlock'
import Switch from '../form/Switch'
import Input from '../form/Input'

const SettingFormGroup: FC<{
  settingGroupState: ISetting[]
  handleUpdate: (id: ISetting['idSetting'], value?: string) => void
  title: string
  description?: string
  loading?: boolean
}> = ({ settingGroupState, title, description, loading, handleUpdate }) => {
  return (
    <FormBlock
      title={title}
      subTitle={description}
      className='col-span-12 grid grid-cols-12 gap-6  p-4'
    >
      {settingGroupState.map(
        ({ idSetting, type, name, title, value, description, radio_group }) => (
          <div
            key={`setting-${idSetting}`}
            className='col-span-6'
          >
            {(type === 'boolean' && (
              <Switch
                label={title}
                description={description}
                name={`field-${idSetting}`}
                size='small'
                isNoLabelArea
                value={!!+value}
                handleToggle={() => handleUpdate(idSetting)}
                disabled={loading}
                className='flex gap-1'
              />
            )) ||
              (type === 'number' && (
                <div>
                  <Input
                    label={title}
                    description={description}
                    name={`field-${idSetting}`}
                    classNameField='text-center'
                    maxLength={2}
                    value={value}
                    handle={(event) =>
                      handleUpdate(
                        idSetting,
                        String(event.target.value.trim().match(/\d+/g) || '0'),
                      )
                    }
                  />
                </div>
              ))}
          </div>
        ),
      )}
    </FormBlock>
  )
}

export default SettingFormGroup
